module.exports = __webpack_public_path__ + "img/prolungato_bilaterale_sx.6a6c6db7.png";